<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card v-if="!is_on_create" v-can="'view-order'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true" id="customer_orders_list_filters">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-4">
              <div class="p-2 border border-solid d-theme-border-grey-light rounded">
                <label class="text-sm opacity-100 text-bold mb-1 block">Order Date</label>
                <div class="vx-row">
                  <div class="vx-col w-1/2">
                    <flat-pickr
                      class="w-full"
                      :config="{ dateFormat: 'd/m/Y'}"
                      v-model="filters['date-from']"
                      placeholder="From"
                    />
                  </div>
                  <div class="vx-col w-1/2">
                    <flat-pickr
                      class="w-full"
                      :config="{ dateFormat: 'd/m/Y'}"
                      v-model="filters['date-to']"
                      placeholder="To"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-4">
              <div class="p-2 border border-solid d-theme-border-grey-light rounded">
                <label class="text-sm opacity-100 text-bold mb-1 block">Due Date</label>
                <div class="vx-row">
                  <div class="vx-col w-1/2">
                    <flat-pickr
                      class="w-full"
                      :config="{ dateFormat: 'd/m/Y'}"
                      v-model="filters['due-date-from']"
                      placeholder="From"
                    />
                  </div>
                  <div class="vx-col w-1/2">
                    <flat-pickr
                      class="w-full"
                      :config="{ dateFormat: 'd/m/Y'}"
                      v-model="filters['due-date-to']"
                      placeholder="To"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-4">
              <div class="p-2 border border-solid d-theme-border-grey-light rounded">
                <label class="text-sm opacity-100 text-bold mb-1 block">Shipment Date</label>
                <div class="vx-row">
                  <div class="vx-col w-1/2">
                    <flat-pickr
                      class="w-full"
                      :config="{ dateFormat: 'd/m/Y'}"
                      v-model="filters['shipment-date-from']"
                      placeholder="From"
                    />
                  </div>
                  <div class="vx-col w-1/2">
                    <flat-pickr
                      class="w-full"
                      :config="{ dateFormat: 'd/m/Y'}"
                      v-model="filters['shipment-date-to']"
                      placeholder="To"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mt-2">
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-4">
              <label class="text-sm opacity-100 text-bold">Order Item Status</label>
              <v-select :clearable="true" placeholder="" v-model="filters['status']"
                        :options="status_list" :reduce="option => option.value" label="name"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'" multiple></v-select>
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-4">
              <label class="text-sm opacity-100 text-bold">Show Orders Except</label>
              <v-select :clearable="true" placeholder="" v-model="filters['inverse-status']"
                        :options="status_list" :reduce="option => option.value" label="name"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'" multiple></v-select>
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-4">
              <label class="text-sm opacity-100 text-bold">Ordered By</label>
              <v-select name="staffs" :closeOnSelect="false" :clearable="false"
                v-model="filters['ordered-by']" :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :reduce="option => option.value" label="name" multiple />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-4">
              <label class="text-sm opacity-100 text-bold">Account Handler</label>
              <v-select name="staffs" :closeOnSelect="false" :clearable="false"
                v-model="filters['account-handler-id']" :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :reduce="option => option.value" label="name" multiple />
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-4">
              <label class="text-sm opacity-100 text-bold">Account Type</label>
              <v-select :clearable="true" name="account-type" placeholder="" v-model="filters['account-type']" 
              :options="['credit', 'proforma']"/>
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-4">
              <label class="text-sm opacity-100 text-bold">Filter By Invoice State</label>
              <div class="vx-row">
                <div class="vx-col w-1/5 mt-2 text-sm">
                  <span :class="`${is_invoice_pending ? '' : 'text-primary'}`">show all</span>
                </div>
                <div class="vx-col w-1/5 ml-0">
                  <vs-switch v-model="is_invoice_pending" class="mt-2"/>
                </div>
                <div class="vx-col w-3/5 mt-2 text-sm ml-0">
                  <span :class="`${is_invoice_pending ? 'text-primary' : ''}`">show only SO missing invoices</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!customerId" class="vx-row mt-2">
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-4">
              <label class="text-sm opacity-100 text-bold">Currency</label>
              <v-select :clearable="true" name="currency" placeholder=""
                        label="name" v-model="filters['currency']" :reduce="option => option.code"
                        :options="currencies" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            </div>
            <div class="vx-col md:w-1/6 sm:w-1/2 w-full mb-4">
              <label class="text-sm opacity-100 text-bold">Customer Status</label>
              <v-select :clearable="true" name="currency" placeholder="" v-model="filters['customer_status']"
                        :options="customer_status_list" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            </div>
          </div>
          <div class="vx-row mt-2">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>

        <vx-card v-if="!is_on_create" class="pt-4">
          <div slot="no-body" class="mt-4">
            <vs-table id="customer-product-orders-table" v-can="'view-order'" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff"
                      @sort="handleSort"
                      :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">
              <template slot="header">
                <div class="vx-row w-full ml-4 mb-8">
                  <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Search</label>
                    <vs-input type="search"  placeholder="General Search..." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
                  </div>
                  <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Expand search to include FG codes</label>
                    <vs-switch v-model="is_internal_search" icon-pack="feather" vs-icon-on="icon-check-circle"
                              vs-icon-off="icon-slash" class="mt-3 w-16">
                      <span slot="on">Yes</span>
                      <span slot="off">No</span>
                    </vs-switch>
                  </div>
                  <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Total Order  Value (GBP): <span class="text-success"> {{ totalOrderValue | thousand_seperator}}</span> </label>
                    
                  </div>
                  <div class="vx-col md:w-2/5 sm:w-1/2 w-full pt-4">
                    <vs-button v-can="'create-edit-order'" @click="onClickCreateNewOrder" v-if="customer_stage === 'customer' || !customerId"
                        class="float-right mr-8" color="primary" type="filled">
                    Create new order
                  </vs-button>
                  <excel-download class="mr-2 ml-auto float-right" :name="'customer-order-sheet'" :filters="filters"/>
                  </div>
                </div>
              </template>
              <template slot="thead">
                <vs-th width="8%">ITS ORDER NUMBER</vs-th>
                <vs-th width="7%">ORDER DATE</vs-th>
                <vs-th width="7%" sort-key="shipment-date">SHIP BY DATE</vs-th>
                <vs-th width="7%" sort-key="required_by">REQUIRED BY DATE</vs-th>
                <vs-th width="2%"></vs-th>
                <vs-th width="8%">CUSTOMER'S PO NUMBER</vs-th>
                <vs-th width="14%" v-if="!customerId">CUSTOMER</vs-th>
                <vs-th width="14%">FINISHED PRODUCTS</vs-th>
                <vs-th width="7%">INVOICES</vs-th>
                <vs-th width="7%">ORDER VALUE</vs-th>
                <vs-th v-if="$can('create-edit-sage-sale-order')" width="4%">SAGE</vs-th>
                <vs-th width="7%">SO STATUS</vs-th>
                <vs-th width="4%">SHORT ORDER</vs-th>
                <vs-th width="3%">OTIF</vs-th>
                <vs-th width="8%" class="">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr  @click.native="onClickOrderDetailsView(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td class="font-semibold" :data="data[indextr].product_order_code">
                    {{ data[indextr].product_order_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].created_at">
                    {{__dateTimeFormatterToDate(data[indextr].created_at)}}
                  </vs-td>

                  <vs-td class="text-center">
                    {{ data[indextr].shipment_date || 'N/A' }}
                  </vs-td>

                  <vs-td>
                    <!-- <span v-if="data[indextr].formulation_items.length === 1">
                      {{ data[indextr].formulation_items[0].required_by }}
                    </span>
                    <span v-else>Multiple</span> -->
                    {{ data[indextr].required_by || 'N/A' }}
                  </vs-td>

                  <vs-td>
                    <vx-tooltip :text="`This is a multi date order`" position="top" v-if="data[indextr].formulation_items.length > 1">
                      <span class="text-danger font-bold text-xs">M</span>
                    </vx-tooltip>
                  </vs-td>

                  <vs-td :data="data[indextr].customers_order_number">
                    {{ data[indextr].customers_order_number || 'N/A'}}
                  </vs-td>

                  <vs-td v-if="!customerId" :data="data[indextr].customer.account_number">
                    <HyperLink :id="data[indextr].customer.id" type="customer">{{ data[indextr].customer.company_name}} <br>
                    <span>{{ data[indextr].customer.account_number}}</span></HyperLink> <br>
                    <span class="text-primary" :class="{ 'text-danger' : data[indextr].account_credit_type === 'proforma'}">
                      {{ data[indextr].account_credit_type }}
                    </span> | <span class="text-warning">{{ data[indextr].customer.account_currency }}</span>
                  </vs-td>

                  <vs-td :data="data[indextr].formulations">
                    <span v-if="data[indextr].formulation_items.length > 0" v-for="(item, item_index) in data[indextr].formulation_items" :key="item_index">
                       <HyperLink :id="item.formulation_id" type="formulation">{{ item.formulation_code }} ({{ item.formulation_name }})</HyperLink>
                        <span class="text-primary break-words" v-if="data[indextr].formulation_items.length - 1 !== item_index"> , </span>
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].invoices">
                    <span v-if="data[indextr].invoices.length > 0" v-for="(invoice, invoice_index) in data[indextr].invoices" :key="invoice_index">
                      <span class="break-normal">{{ invoice.number }}</span>
                        <span class="text-primary break-words" v-if="data[indextr].invoices.length - 1 !== invoice_index"> , </span>
                    </span>
                  </vs-td>

                  <vs-td>
                    {{ totalCalculator(data[indextr].formulation_items, data[indextr].customer.account_currency, data[indextr].add_costs)}}
                  </vs-td>

                  <vs-td v-if="$can('create-edit-sage-sale-order')">
                    <span v-if="data[indextr].sage_product_order_id || data[indextr].sage_order_number">
                      <vx-tooltip class="mr-2" :text="`Sage Ref: ${data[indextr].sage_order_number ? data[indextr].sage_order_number : data[indextr].sage_product_order_id}`" position="left">
                      <vs-button size="small" color="primary" type="filled" icon-pack="feather" icon="icon-check"/>
                      </vx-tooltip>
                    </span>
                    <span class="text-danger cursor-pointer" v-else>
                      <vx-tooltip class="mr-2" text="Sync order with sage" position="left">
                        <vs-button @click.stop="onClickSageSyncOrder(data[indextr])"
                                 size="small" color="danger" type="filled" icon-pack="feather" icon="icon-refresh-cw"></vs-button>
                      </vx-tooltip>
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <!-- <vs-chip v-if="data[indextr].formulation_items.length === 1" style="border-radius: 0" transparent :color="ProductOrderStatusColorFactory(data[indextr].formulation_items[0].item_status)">
                      {{  data[indextr].formulation_items[0].item_status === 'Pending' ? 'Accepted' : data[indextr].formulation_items[0].item_status }}
                    </vs-chip>
                    <vs-chip v-else>
                      Multiple items
                    </vs-chip> -->
                    <vs-chip style="border-radius: 0" transparent>
                      {{ salesOrderStatusFactory(data[indextr].formulation_items) }}
                    </vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].short_lead">
                    <vs-chip v-if="data[indextr].short_lead" color="success">Yes</vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].otif_status">
                    <vs-chip transparent :color="data[indextr].otif_status === 'N/A' ? 'dark' : (data[indextr].otif_status ? 'success' : 'danger')">{{ data[indextr].otif_status === 'N/A' ? 'N/A' : (data[indextr].otif_status ? 'Yes' : 'No') }}</vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="flex items-center">
                      <vx-tooltip class="mr-2" text="View Order" position="top">
                        <vs-button @click.stop="onClickOrderDetailsView(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="isAllItemsInAcceptedStatus(data[indextr].formulation_items) && $can('create-edit-order')" class="mr-2" text="Update Address" position="top">
                        <vs-button @click.stop="onClickProductOrderUpdate(data[indextr])"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>

                      <vx-tooltip class="mr-2" text="Overdue" position="top" v-if="checkOverDue(data[indextr].created_at, data[indextr].status.id)">
                        <vs-button size="small" color="danger" type="filled" icon-pack="feather" icon="icon-bell"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="mr-2" text="Order change request" position="top" v-if="checkChangeRequest(data[indextr].formulation_items)">
                        <vs-button size="small" color="warning" type="filled" icon-pack="feather" icon="icon-alert-triangle"></vs-button>
                      </vx-tooltip>

<!--                      <vx-tooltip class="mr-2" text="Invoice still pending" position="top" v-if="data[indextr].is_invoice_pending === 'Yes'">-->
<!--                        <vs-button size="small" color="danger" type="filled" icon-pack="feather" icon="icon-paperclip"></vs-button>-->
<!--                      </vx-tooltip>-->

                    </div>
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>
<!--            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>-->
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>

          </div>
        </vx-card>
        <customer-cart-list ref="customerCartList" :initial_search="cart_search_query" v-bind:customer_id="customerId + ''" v-bind:account_currency="account_currency" v-on:back="refreshData($event)" v-if="is_on_create" :sales_quote_id="sales_quote_id" :create_from_sales_quote="create_from_sales_quote"/>
      </div>
    </div>
    <update-customer-product-order-pop-up ref="updateCustomerProductOrderPopUp"/>

    <vs-prompt
      @accept="changeStatus"
      @close="activePrompt = false"
      :title="'Create customer order'"
      :accept-text="'Confirm'"
      :color="'primary'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Select customer</span>
        <v-select
          :clearable="true" name="customerId" placeholder=""
          v-model="selected_customer_obj"
          label="company_name"
          :options="customer_list"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            <vs-alert v-if="selected_customer_obj.status === 'On Hold'" icon-pack="feather" icon="icon-info" class="h-full mt-8 mb-4" color="warning">
              <span>This account is on HOLD. You can place an order but this will not be manufactured unless the account is changed back to an active status.</span>
            </vs-alert>
      </div>
    </vs-prompt>

  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  const SageRepository = RepositoryFactory.get('sage')
  const StaffRepository = RepositoryFactory.get('staff')
  const DropDownRepository = RepositoryFactory.get('drop_down')
  import UpdateCustomerProductOrderPopUp from '@/components/popups/customer/product-orders/UpdateCustomerProductOrderPopUp'
  import CustomerCartList from './CustomerCartList'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Utils from '@/mixins/Utils'
  import ProductOrderTable from './ProductOrderTable'
  import moment from 'moment';
  import {product_order_statuses, product_order_item_statuses} from '@/constants/statuses'
  import {defaultPagination, perPageList} from "@/constants/config";
  import { mapGetters, mapActions } from 'vuex';

  import flatPickr from "vue-flatpickr-component";
  import 'flatpickr/dist/flatpickr.css'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        currencies: [],
        sales_quote_id: null,
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: '',
        selected_customer_obj: { status: '' },
        is_on_create: false,
        cart_search_query: '',
        product_order_statuses: product_order_statuses,
        product_order_item_statuses: product_order_item_statuses,
        activePrompt: false,
        customer_list: [],
        perPage: defaultPagination,
        descriptionItems: perPageList,
        is_internal_search: false,
        is_invoice_pending: false,
        dateSortOrder: 1,
        create_from_sales_quote: false,
        status_list: [
          { name: 'Submitted', value: 'Submitted' },
          { name: 'Accepted', value: 'Pending' },
          { name: 'In-Manufacturing', value: 'In-Manufacturing' },
          { name: 'Pending Dispatch', value: 'Pending Dispatch'},
          { name: 'In-QC', value: 'In-QC' },
          { name: 'In-Dispatch', value: 'In-Dispatch' },
          { name: 'Dispatched', value: 'Dispatched' },
          { name: 'Customer-Received', value: 'Customer-Received' },
          { name: 'Returned', value: 'Returned' },
          { name: 'Part Returned', value: 'Part Returned' },
          { name: 'Goods-Lost', value: 'Goods-Lost' },
          { name: 'Rejected/Cancelled', value: 'Cancelled' },
        ],
        customer_status_list: [
          'Approved',
          'Rejected',
          'On Hold',
          'Pending Customer',
          'Lead',
          'Pending Verification',
          'Opportunity',
        ],
        totalOrderValue : ''
      }
    },
    props: {
      account_currency  : {
        type: String,
        default: 'GBP',
      },
      customer_stage: {
        type: String,
        default: ''
      }
    },
     computed: {
      ...mapGetters(['staffs'])
    },
    components: {
      'v-select': vSelect,
      UpdateCustomerProductOrderPopUp,
      CustomerCartList,
      ProductOrderTable,
      flatPickr,
    },
    mixins : [Filter, SuccessMessage, ErrorMessages, Utils],
    async mounted () {
      // this.$refs.filterCard.isContentCollapsed = true
      // this.$refs.filterCard.maxHeight = '1.5rem'

      this.customerId = this.$route.params.id ? this.$route.params.id : null
      this.setFilterId('customer_orders_list_filters',['currency','status'])
      await this.fetchCurrencies()
      await this.fetchStaffs()

     const { 'shipment-date-from': from, 'shipment-date-to': to, 'type':type } = { ...this.$route.params, ...this.$route.query }
      if (from || to) {
        if (from) this.$set(this.filters, 'shipment-date-from', from)
        if (to) this.$set(this.filters, 'shipment-date-to', to)
        if(type){
          if(type === 'shipped'){
            this.$set(this.filters, 'status' , ['Dispatched', 'Customer-Received', 'Returned', 'Part Returned'] )
          }else if(type === 'expected'){
            this.$set(this.filters, 'status' , ['Submitted', 'Pending', 'In-QC', 'In-Manufacturing','Pending Dispatch'] )
          }
        }
        if (this.$route.query['shipment-date-from'] || this.$route.query['shipment-date-to']) {
          this.$router.replace({ path: this.$route.path }).catch(() => {})
        }
      }

      if (this.$route.query.create) {
        await this.createProductOrderFromSalesQuote()
      }
    },
    methods: {
      ...mapActions(['fetchStaffs']),
      async refreshData () {
        this.is_on_create = false
        this.cart_search_query = ''
        this.customerId = this.$route.params.id ? this.$route.params.id : null
        await this.getProductOrderList()
      },
      async fetchCurrencies() {
        this.$vs.loading()
        try {
          const {data} =  (await StaffRepository.getCurrencyList()).data
          this.currencies = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async getProductOrderList() {
        await this.$vs.loading()
        try {
          let data = []
          if (!!this.customerId) {
            data = (await CustomerRepository
              .getListOfProductOrders(this.customerId, this.page, this.filterQuery+`&is_internal_search=${this.is_internal_search}&is_invoice_pending=${this.is_invoice_pending}`,
              this.perPage, this.sort)).data
          } else {
            data = (await CustomerRepository
              .getAllProductOrders(this.page, this.filterQuery+`&is_internal_search=${this.is_internal_search}&is_invoice_pending=${this.is_invoice_pending}`,
                this.perPage, this.sort)).data
          }
          this.staff =  data.data
          this.meta = data.meta
          this.totalOrderValue = data.total_value
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async onClickOrderDetailsView (id) {
        this.$router.push({path: `/pages/product-orders/${id}`})
      },
      async createProductOrderFromSalesQuote() {
        this.sales_quote_id = this.$route.query.quote_id
        this.customerId = this.$route.query.customer_id
        this.account_currency = this.$route.query.customer_id
        this.create_from_sales_quote = true
        this.is_on_create = true
      },
      async onClickProductOrderUpdate (data) {
        await this.$refs.updateCustomerProductOrderPopUp.openPopup(data.id, data.customer.id)
      },
      async onClickCreateNewOrder() {
        this.cart_search_query = ''
        if(this.$route.params.id) {
          this.is_on_create = true
        } else {
          await this.fetchCustomerList()
          this.activePrompt = true
        }
      },
      openCreateOrderWithSearch(productCode) {
        this.cart_search_query = productCode
        this.is_on_create = true
        this.$nextTick(() => {
          if (this.$refs.customerCartList) {
            this.$refs.customerCartList.setSearchQuery(productCode)
          }
        })
      },
      checkOverDue(date, status_id) {
        let now = moment()
        let ddd = moment(date)
        let gap = now.diff(ddd, 'days')
        return gap > 13 && [1, 2].includes(status_id);
      },
      checkChangeRequest(items) {
        return items.some(item => item.change_requests)
      },

      filterQueryUpdate (){
        this.page = 1
        this.getProductOrderList()
      },

      handleChangePage(page) {
        this.page=page;
        this.getProductOrderList()
      },
      async handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          await this.getProductOrderList()
        }
      },
      changePage(index) {
        this.page = 1
        this.perPage = this.descriptionItems[index]
      },
      ProductOrderStatusColorFactory(status_name) {
        const status = this.product_order_item_statuses.find((n) =>  n.name === status_name)
        return status ? status.color : 'dark'
      },
      onClickFinishedProduct(id) {
        this.$router.push({path: `/pages/formulations/${id}`})
      },
      onClickFormula(id) {
        this.$router.push({path: `/pages/formulations/${id}`})
      },
      onClickStatusChangeConfirm(id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onChangeSampleOrderStatus,
          parameters: [id, status]
        })
      },
      async onChangeSampleOrderStatus(params){
        this.$vs.loading()
        try {
          await CustomerRepository.statusChangeCustomerProductOrders(params[0], params[1])
          this.showSuccessMessage('Status change successfully!')
          await this.getProductOrderList()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      totalCalculator(data, account_currency = '', add_costs = []) {
        const total =  data.filter((x) => x.item_status !== 'Cancelled').reduce((acc, obj) => {return acc + Number(obj.price) * Number(obj.quantity)}, 0) + add_costs.reduce((acc, obj) => {return acc + Number(obj.amount) *(1 + (Number(obj.vat_percent) / 100))}, 0)
        let currency_cymbol = this.__currencySymbol(account_currency)
        return currency_cymbol + ' ' + total.toLocaleString()
      },
      isAllItemsInAcceptedStatus(arr) {
        return this.checkKeyHasAllSameValue(arr, 'item_status', 'Submitted')
      },
      async fetchCustomerList() {
        await this.$vs.loading({
          container: '#customer-product-orders-table',
          scale: 0.45
        })
        try {
          const { data } = await DropDownRepository.getCustomersList( `filter[status]=Approved,On Hold`)
          this.customer_list = data.data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#customer-product-orders-table > .con-vs-loading')
      },
      changeStatus() {
        this.customerId = this.selected_customer_obj.id
        this.account_currency = this.selected_customer_obj.account_currency
        this.is_on_create = true
      },
      async onClickSageSyncOrder(data) {
        const total_value = data.formulation_items.reduce((a, b) => a + Number(b.quantity) * Number(b.price), 0)
        let payload = {
          product_order_id: data.id,
          customer_id: data.customer.sage_id,
          document_no: data.product_order_code,
          customer_document_no: data.product_order_code,
          lines: data.formulation_items.map((n) => {
            return {
              line_type: "1",
              use_description: true,
              description: `${n.formulation_code} ${n.formulation_name}`,
              line_quantity: n.quantity + '',
              allocated_quantity: n.quantity + '',
              selling_unit_price: n.price + '',
              // tax_code_id: 1728
            }
          })
        }
          if (data.customer.sage_id) {
          this.$vs.loading()
          try {
            await SageRepository.createSalesOrder(payload)
            await this.getProductOrderList()
          } catch (e) {

          }
          this.$vs.loading.close()
        } else {
          this.$vs.dialog({
            color: 'danger',
            title: `Warning`,
            text: 'This customer is not synchronised on Sage. You must do that before you can attempt to synchronise any sales order.',
            acceptText: 'Close'
          })
        }
      },
      salesOrderStatusFactory(items) {
        if (items.length === 0) {
          return 
        }
        const firstItemStatus = items[0].item_status;
        const allItemsHaveSameStatus = items.every(item => item.item_status === firstItemStatus);
        return (items.length === 1 && firstItemStatus === 'Pending') ? 'Accepted' : (allItemsHaveSameStatus ? (firstItemStatus === 'Pending' ? 'Accepted' : firstItemStatus) : 'Multiple Items');
      }
    },
    watch : {
      page(){
        this.getProductOrderList()
      },
      perPage() {
        this.getProductOrderList()
      },
      is_internal_search: function () {
        this.getProductOrderList()
      },
      is_invoice_pending: function () {
        this.getProductOrderList()
      }
    },
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  table td {
    vertical-align: top;
    /* min-width: 140px; */
    /* padding-bottom: .8rem; */
    /* word-break: break-all; */
  }

</style>
